import { initializeApp } from "firebase/app";
import {
  initializeAuth,
  browserLocalPersistence,
  inMemoryPersistence,
  GoogleAuthProvider,
} from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getAnalytics } from "firebase/analytics";
import { Capacitor } from "@capacitor/core";

const firebaseConfig = {
  apiKey: "AIzaSyDD5KQ16QGC9oU5NsUm-LQNd_PtnOy84qU",
  authDomain: "waiting-list-easy.firebaseapp.com",
  projectId: "waiting-list-easy",
  storageBucket: "waiting-list-easy.firebasestorage.app",
  messagingSenderId: "47425390859",
  appId: "1:47425390859:web:4215cf19b2509e48e07a0e",
  measurementId: "G-XERCSHRRYJ"
};

const app = initializeApp(firebaseConfig);

// Explicit persistence avoids Firebase's auto-detection chain which can hang
// in iOS WKWebView. Native uses localStorage; web gets localStorage too so
// the user stays logged in across sessions.
const auth = initializeAuth(app, {
  persistence: Capacitor.isNativePlatform()
    ? [browserLocalPersistence, inMemoryPersistence]
    : [browserLocalPersistence],
});

const provider = new GoogleAuthProvider();
const db = getDatabase(app);

// Analytics requires browser APIs unavailable in native WebView — web only
if (!Capacitor.isNativePlatform()) {
  getAnalytics(app);
}

export { auth, provider, db };
